import { TypeEvalEnum } from "@convex/schema";
import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";
import { useCandidateAuthStore } from "@repo/auth";
import { Loader2 } from "lucide-react";
import type { EntStructEvaluation } from "../lib/types";
import { isBackendError } from "../lib/types";
import { ChatInterface } from "../components/chat/ChatInterface";
import { Navbar } from "../components/layout/navbar";

export function Home() {
  const token = useCandidateAuthStore((state) => state.token);
  const evaluationId = useCandidateAuthStore((state) => state.evaluationId);
  const parcoursId = useCandidateAuthStore((state) => state.parcoursId);

  const evaluationResponse = useQuery(
    api.evaluations.obtenirEvaluation,
    evaluationId && token && parcoursId ? { evaluationId, parcoursId, token } : "skip",
  );

  // État de chargement
  if (evaluationResponse === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // État d'erreur
  if (isBackendError(evaluationResponse)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">Erreur</h1>
          <p className="mt-2 text-muted-foreground">
            {evaluationResponse.erreur}
          </p>
        </div>
      </div>
    );
  }

  // Vérifie le type d'évaluation
  if (evaluationResponse.evaluation.typeEval !== TypeEvalEnum.ENT_STRUCT) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">
            Type d'évaluation incorrect
          </h1>
          <p className="mt-2 text-muted-foreground">
            Cette évaluation n'est pas un entretien FairView.
          </p>
        </div>
      </div>
    );
  }

  const evaluation = evaluationResponse.evaluation as EntStructEvaluation;

  return (
    <div className="h-dvh flex flex-col overflow-hidden">
      <Navbar />
      <div className="container mx-auto flex-1 flex flex-col sm:items-center sm:justify-center sm:p-4">
        <ChatInterface evaluation={evaluation} token={token} />
      </div>
    </div>
  );
}
